//new style

import { useEffect, useState } from "react";
import axios from "axios";
import API from "../api";

import {
  Wallet,
  ArrowUpRight,
  Users,
  CreditCard,
  AlertTriangle,
  Clock3,
  Activity
} from "lucide-react";

export default function Home() {

  const [data, setData] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {

    axios.get(`${API}/api/transactions`, {
      params: {
        role: user?.role,
        personId: user?.personId
      }
    })
      .then(res => setData(res.data))
      .catch(err => console.log(err));

  }, []);

  const total = data.reduce(
    (sum, t) => sum + Number(t.amount),
    0
  );

  const totalPaid = data.reduce(
    (sum, t) => sum + Number(t.paid || 0),
    0
  );

  // TOTAL WITH INTEREST
  const totalExpected = data.reduce(
    (sum, t) => sum + (Number(t.amount) * 1.75),
    0
  );

  const pending = totalExpected - totalPaid;

  // TODAY
  const today = new Date();

  // DUE TODAY
  const dueToday = data.filter((t) => {

    if (!t.lastDate) return false;

    const due = new Date(t.lastDate);

    return (
      due.getDate() === today.getDate() &&
      due.getMonth() === today.getMonth() &&
      due.getFullYear() === today.getFullYear()
    );

  });

  // OVERDUE
  const overdue = data.filter((t) => {

    if (!t.lastDate) return false;

    const due = new Date(t.lastDate);

    return due < today &&
      (Number(t.paid || 0) < Number(t.amount) * 1.75);

  });

  // UPCOMING DUE
  const upcomingDue = data
    .filter(t => t.lastDate)
    .sort(
      (a, b) =>
        new Date(a.lastDate) - new Date(b.lastDate)
    )
    .slice(0, 5);

  return (
    <div className="p-4 pb-24">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">

        <div>
          <p className="text-gray-500 text-sm">
            Welcome Back
          </p>

          <h1 className="text-3xl font-bold">
            Dashboard
          </h1>
        </div>

        <img
          src="bg.png"
          alt=""
          className="w-12 h-12 rounded-full"
        />

      </div>

      {/* BALANCE CARD */}
      <div className="card-dark text-white rounded-3xl p-6 mb-5">

        <div className="flex justify-between items-start">

          <div>
            <p className="opacity-80">
              Total Money Given
            </p>

            <h1 className="text-4xl font-bold mt-2">
              ₹ {total}
            </h1>

            <p className="mt-3 opacity-80 text-sm">
              {data.length} Transactions
            </p>
          </div>

          <Wallet size={42} />
        </div>

      </div>

      {/* STATS */}
      <div className="grid grid-cols-2 gap-4 mb-5">

        <div className="card">
          <div className="flex justify-between">

            <div>
              <p className="text-gray-500 text-sm">
                Paid
              </p>

              <h2 className="text-2xl font-bold mt-1">
                ₹ {totalPaid}
              </h2>
            </div>

            <ArrowUpRight className="text-green-500" />
          </div>
        </div>

        <div className="card">
          <div className="flex justify-between">

            <div>
              <p className="text-gray-500 text-sm">
                Customers
              </p>

              <h2 className="text-2xl font-bold mt-1">
                {data.length}
              </h2>
            </div>

            <Users className="text-blue-500" />
          </div>
        </div>

      </div>

      {/* DUE + OVERDUE */}
      <div className="grid md:grid-cols-2 gap-4 mb-5">

        {/* DUE TODAY */}
        <div className="card border border-yellow-200">

          <div className="flex justify-between items-center mb-4">

            <h2 className="font-bold text-lg flex items-center gap-2">
              <Clock3 size={20} className="text-yellow-500" />
              Due Today
            </h2>

            <span className="text-sm bg-yellow-100 text-yellow-700 px-2 py-1 rounded-xl">
              {dueToday.length}
            </span>

          </div>

          {dueToday.length === 0 ? (

            <p className="text-gray-500 text-sm">
              No due payments today
            </p>

          ) : (

            dueToday.map((t) => {

              const balance =
                (Number(t.amount) * 1.75) -
                Number(t.paid || 0);

              return (

                <div
                  key={t._id}
                  className="py-3 border-b last:border-none"
                >

                  <div className="flex justify-between">

                    <div>
                      <p className="font-semibold">
                        {t.name}
                      </p>

                      <p className="text-sm text-gray-500">
                        {t.mobile}
                      </p>
                    </div>

                    <p className="font-bold text-yellow-600">
                      ₹ {balance}
                    </p>

                  </div>

                </div>

              );
            })

          )}

        </div>

        {/* OVERDUE */}
        <div className="card border border-red-200">

          <div className="flex justify-between items-center mb-4">

            <h2 className="font-bold text-lg flex items-center gap-2">
              <AlertTriangle size={20} className="text-red-500" />
              Overdue
            </h2>

            <span className="text-sm bg-red-100 text-red-700 px-2 py-1 rounded-xl">
              {overdue.length}
            </span>

          </div>

          {overdue.length === 0 ? (

            <p className="text-gray-500 text-sm">
              No overdue customers
            </p>

          ) : (

            overdue.slice(0, 5).map((t) => {

              const balance =
                (Number(t.amount) * 1.75) -
                Number(t.paid || 0);

              return (

                <div
                  key={t._id}
                  className="py-3 border-b last:border-none"
                >

                  <div className="flex justify-between">

                    <div>
                      <p className="font-semibold">
                        {t.name}
                      </p>

                      <p className="text-sm text-gray-500">
                        {t.mobile}
                      </p>
                    </div>

                    <p className="font-bold text-red-500">
                      ₹ {balance}
                    </p>

                  </div>

                </div>

              );
            })

          )}

        </div>

      </div>

      {/* RECENT */}
      <div className="card mb-5">

        <div className="flex justify-between items-center mb-4">

          <h2 className="font-bold text-lg">
            Recent Transactions
          </h2>

          <CreditCard size={20} />
        </div>

        {data.slice(0, 5).map(t => (

          <div
            key={t._id}
            className="flex justify-between items-center py-3 border-b last:border-none"
          >

            <div>
              <p className="font-semibold">
                {t.name}
              </p>

              <p className="text-sm text-gray-500">
                {t.mobile}
              </p>
            </div>

            <div className="text-right">
              <p className="font-bold">
                ₹ {t.amount}
              </p>

              <p className="text-green-600 text-sm">
                Paid ₹ {t.paid || 0}
              </p>
            </div>

          </div>

        ))}

      </div>

      {/* UPCOMING DUE */}
      <div className="card mb-5">

        <div className="flex justify-between items-center mb-4">

          <h2 className="font-bold text-lg">
            Upcoming Due Dates
          </h2>

          <Clock3 size={20} />
        </div>

        {upcomingDue.map((t) => (

          <div
            key={t._id}
            className="flex justify-between items-center py-3 border-b last:border-none"
          >

            <div>
              <p className="font-semibold">
                {t.name}
              </p>

              <p className="text-sm text-gray-500">
                {new Date(t.lastDate).toLocaleDateString()}
              </p>
            </div>

            <div className="text-right">

              <p className="font-bold">
                ₹ {
                  (Number(t.amount) * 1.75) -
                  Number(t.paid || 0)
                }
              </p>

            </div>

          </div>

        ))}

      </div>

      {/* RECENT ACTIVITY */}
      <div className="card">

        <div className="flex justify-between items-center mb-4">

          <h2 className="font-bold text-lg">
            Recent Activity
          </h2>

          <Activity size={20} />
        </div>

        {data.slice(0, 5).map((t) => (

          <div
            key={t._id}
            className="py-3 border-b last:border-none"
          >

            <p className="font-medium">
              {t.name} paid ₹ {t.paid || 0}
            </p>

            <p className="text-sm text-gray-500">
              Loan Amount ₹ {t.amount}
            </p>

          </div>

        ))}

      </div>

    </div>
  );
}